__turbopack_context__.v({
  "chevron": "search-bar-module__IXrm2a__chevron",
  "chevronRotated": "search-bar-module__IXrm2a__chevronRotated",
  "container": "search-bar-module__IXrm2a__container",
  "disabled": "search-bar-module__IXrm2a__disabled",
  "divider": "search-bar-module__IXrm2a__divider",
  "dropdown": "search-bar-module__IXrm2a__dropdown",
  "dropdownContent": "search-bar-module__IXrm2a__dropdownContent",
  "dropdownHint": "search-bar-module__IXrm2a__dropdownHint",
  "dropdownMenu": "search-bar-module__IXrm2a__dropdownMenu",
  "dropdownOpen": "search-bar-module__IXrm2a__dropdownOpen",
  "dropdownOption": "search-bar-module__IXrm2a__dropdownOption",
  "dropdownOptionActive": "search-bar-module__IXrm2a__dropdownOptionActive",
  "dropdownSearch": "search-bar-module__IXrm2a__dropdownSearch",
  "dropdownSearchInput": "search-bar-module__IXrm2a__dropdownSearchInput",
  "fieldContainer": "search-bar-module__IXrm2a__fieldContainer",
  "gpsButton": "search-bar-module__IXrm2a__gpsButton",
  "gpsError": "search-bar-module__IXrm2a__gpsError",
  "hasSelectedText": "search-bar-module__IXrm2a__hasSelectedText",
  "locationInputWithGps": "search-bar-module__IXrm2a__locationInputWithGps",
  "placeholderText": "search-bar-module__IXrm2a__placeholderText",
  "resultsSection": "search-bar-module__IXrm2a__resultsSection",
  "searchBar": "search-bar-module__IXrm2a__searchBar",
  "searchButton": "search-bar-module__IXrm2a__searchButton",
  "selectedText": "search-bar-module__IXrm2a__selectedText",
  "textInput": "search-bar-module__IXrm2a__textInput",
  "textInputContainer": "search-bar-module__IXrm2a__textInputContainer",
  "textInputDisabled": "search-bar-module__IXrm2a__textInputDisabled",
  "textInputTitle": "search-bar-module__IXrm2a__textInputTitle",
  "textInputValue": "search-bar-module__IXrm2a__textInputValue",
  "wideField": "search-bar-module__IXrm2a__wideField",
});
